import { render, staticRenderFns } from "./MapUA.vue?vue&type=template&id=665ee17b&"
import script from "./MapUA.vue?vue&type=script&lang=js&"
export * from "./MapUA.vue?vue&type=script&lang=js&"
import style0 from "./MapUA.vue?vue&type=style&index=0&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports